import { Box, Card, CloseButton, Flex, Progress, Text, useColorModeValue } from "@chakra-ui/react";
import { DocumentQuery } from "@metriport/api-sdk";
import { useEffect, useState } from "react";

export const DocumentProgressContainer = ({ dqProgress }: { dqProgress: DocumentQuery }) => {
  const [isClosed, setIsClosed] = useState(false);
  const total = dqProgress.convert?.total ?? 0;
  const isProcessing = dqProgress.convert?.status === "processing" && total > 0;

  useEffect(() => {
    if (!isProcessing) {
      setIsClosed(false);
    }
  }, [isProcessing]);

  const completed = (dqProgress.convert?.successful ?? 0) + (dqProgress.convert?.errors ?? 0);
  const progressValue = total ? (completed / total) * 100 : 0;

  const bgColor = useColorModeValue("white", "gray.900");

  function handleClose() {
    setIsClosed(true);
  }

  if (!isProcessing || isClosed) {
    return null;
  }

  return (
    <Box
      w={"100%"}
      position="fixed"
      left={0}
      right={0}
      bottom={"100px"}
      display="flex"
      justifyContent="center"
      pointerEvents="none"
    >
      <Card bg={bgColor} border={"solid #d3d3d3 1px"} p={5} w={500} mx={5} pointerEvents="auto">
        <Flex mb={2} justifyContent={"space-between"} alignItems="center">
          <Text>Querying documents</Text>
          <Flex alignItems="center" gap={1}>
            <Text>
              {completed} / {total}
            </Text>
            <CloseButton size="sm" aria-label="Close" onClick={handleClose} />
          </Flex>
        </Flex>
        <Progress colorScheme={"purple"} hasStripe value={progressValue} />
      </Card>
    </Box>
  );
};
